import type { MeResult } from '@/lib/api/apiTypes';

type StoredSession = {
  accessToken: string;
  refreshToken: string;
  me: MeResult;
  emailVerified?: boolean;
};

const STORAGE_KEY = 'radious:session';

export async function readStoredSession() {
  const raw = globalThis.sessionStorage?.getItem(STORAGE_KEY);
  if (raw) {
    return JSON.parse(raw) as StoredSession;
  }

  const legacyRaw = globalThis.localStorage?.getItem(STORAGE_KEY);
  if (!legacyRaw) {
    return null;
  }

  // Web sessions are tab-scoped now; localStorage is only a one-time migration path for old tokens.
  globalThis.sessionStorage?.setItem(STORAGE_KEY, legacyRaw);
  globalThis.localStorage?.removeItem(STORAGE_KEY);
  return JSON.parse(legacyRaw) as StoredSession;
}

export async function writeStoredSession(session: StoredSession) {
  globalThis.sessionStorage?.setItem(STORAGE_KEY, JSON.stringify(session));
  globalThis.localStorage?.removeItem(STORAGE_KEY);
}

export async function clearStoredSession() {
  globalThis.sessionStorage?.removeItem(STORAGE_KEY);
  globalThis.localStorage?.removeItem(STORAGE_KEY);
}
